import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import HeaderPublic from 'components/Header/HeaderPublic';

import { LayoutProps } from '../types';

import * as S from './styled';

const AuthLayout = ({ children, titleKey }: LayoutProps) => {
    const { t } = useTranslation();

    useEffect(() => {
        document.title = t(titleKey);
    }, [t, titleKey]);

    return (
        <S.BodyContainer>
            <HeaderPublic />

            <S.MainContainer>{children}</S.MainContainer>
        </S.BodyContainer>
    );
};

export default AuthLayout;
